import type { T } from "../acts/environment/i18nTypes";

/** Os processos do eixo de aderência, com o nome que o card usa (#879). */
export const PROCESS_LABELS = (t: T): Record<string, string> => ({
  procure_to_pay: t("Procure-to-Pay"),
  order_to_cash: t("Order-to-Cash"),
  record_to_report: t("Record-to-Report"),
  plan_to_produce: t("Plan-to-Produce"),
  other: t("Industry and cross-cutting"),
});

export type FitColor = "activate" | "decision";

export interface FitSegment {
  key: FitColor;
  label: string;
  className: string;
  /** O que a cor quer dizer, na linguagem do Fit-to-Standard. */
  meaning: string;
}

/**
 * As cores da barra de aderência, com o rótulo do card e o que cada uma quer
 * dizer. São o **veredito** do escopo aprovado (21/10/2026): no Diagnóstico a
 * leitura do motor ECC não aparece, e por isso "Precisa de revisão" e "Ignorar",
 * que eram dela, saíram. "Precisa de decisão" passou a querer dizer o que diz.
 */
export const FIT_SEGMENTS = (t: T): FitSegment[] => [
  {
    key: "activate",
    label: t("Activate"),
    className: "bg-[#27a155]",
    meaning: t("Decided in the Fit-to-Standard: it enters the scope and the GROW standard covers it."),
  },
  {
    key: "decision",
    label: t("Needs decision"),
    className: "bg-[#ffc83d]",
    meaning: t("Still being decided in the Fit-to-Standard: your team chooses the path."),
  },
];

export type ProcessDestinationKey = "activate" | "decision";

/** Os dois destinos do card "Destino provável dos processos", com a cor dele. */
export const PROCESS_DESTINATIONS = (
  t: T,
): { key: ProcessDestinationKey; label: string; className: string }[] => [
  { key: "activate", label: t("GROW standard, direct"), className: "bg-[#27a155]" },
  { key: "decision", label: t("Assisted decision"), className: "bg-[#ffc83d]" },
];
